import styled from "@emotion/styled";
import { DefaultComponentVariantType } from "src/domains/layouts/config/features/types";
import { withConfig } from "src/withConfig";

interface CardStyledPropsType {
    haveBorder: boolean;
    variant: DefaultComponentVariantType | null;
}

export const CardStyled = withConfig(theme => styled('div', { label: 'CardStyled' })<CardStyledPropsType>`
    padding: 16px;
    width: 100%;
    border-radius: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.medium : theme.star.radius.small};
    background-color: ${theme.star.card.bgColor};
    color: ${theme.star.card.txtColor};
    border: ${({ haveBorder }): string => haveBorder ? `1px solid ${theme.star.card.borderColor}`: ''};
`);
